import { render, staticRenderFns } from "./KioskRestartButton.vue?vue&type=template&id=59fde2f6"
import script from "./KioskRestartButton.vue?vue&type=script&lang=js"
export * from "./KioskRestartButton.vue?vue&type=script&lang=js"
import style0 from "./KioskRestartButton.vue?vue&type=style&index=0&id=59fde2f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports